import { FC, Fragment, useState } from 'react';
// Hooks
import useToggle from 'hooks/useToggle';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
// Components
import { Button } from './Buttons';
import PrizesDialog from 'dialogs/Prizes.dialog';
// Icons
import { FaStar } from "react-icons/fa";
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  prizes: string[];
  spotPrizes?: string[];
}

const Prizes:FC<Props> = ({ prizes, spotPrizes }) => {
  const { t } = useTranslation();

  const quiz:IQuiz | null = useAppSelector(selectQuiz);

  const [isHovered, setIsHovered] = useState(false);

  const { open, toggle } = useToggle();

  const prizesLength = prizes.length + (spotPrizes?.length || 0);

  if ( !quiz || (!prizesLength) ) return null;
  return (
    <Fragment>
      {open ? <PrizesDialog onClose={toggle} prizes={prizes} spotPrizes={spotPrizes} /> : null}
      <Button
        className="w-10/12 mx-auto mb-4 flex items-center justify-between font-bold !text-xl"
        style={{
          transition: 'background 0.3s',
          color: quiz.prizesButtonFontColor,
          background: isHovered
            ? `linear-gradient(to bottom, ${quiz.prizesButtonGradientStart}, ${quiz.prizesButtonGradientEnd}`
            : `linear-gradient(to bottom, ${quiz.prizesButtonGradientEnd}, ${quiz.prizesButtonGradientStart}`
        }}
        onClick={toggle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <FaStar className="text-white text-xl ml-2" />
          {prizesLength > 1 ? t('buttons.viewPrizes') : t('buttons.viewPrize')}
        <FaStar className="text-white text-xl mr-2" />
      </Button>
    </Fragment>
  )
}

export default Prizes;
